import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import { setupAxiosInterceptors } from "./utilities/datadog/axiosInterceptors";
// These top two imports allow for edge and ie 10 + 11 to run the javascript
import datadogLogger from "./utilities/datadog/DatadogLogger";

if (process.env.REACT_APP_DATADOG_ENABLED === "true") {
	datadogLogger.init({
		clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN ?? "",
		site: process.env.REACT_APP_DATADOG_SITE,
		service: process.env.REACT_APP_DATADOG_SERVICE,
	});
	setupAxiosInterceptors();
}

import { Suspense } from "react";
import Loader from "./components/common/Loader";
// CSS Imports
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.css";
import "./styles/CustomVariants.css";
import "./styles/datetime.css";
import "./styles/devices.min.css";
import "react-circular-progressbar/dist/styles.css";
import "react-quill-v2.0/dist/quill.snow.css";
import ReactDOM from "react-dom/client";
// Redux imports
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import store from "./store/store";
import Dialog from "./utilities/Dialog";

const root = ReactDOM.createRoot(
	document.getElementById("root") as HTMLElement,
);

root.render(
	<Provider store={store}>
		<Suspense
			fallback={
				<div className="vw-100 vh-100 d-flex justify-content-center align-items-center">
					<Loader title="Caching Page..." />
				</div>
			}
		>
			<Router
				getUserConfirmation={async (message: string, callback: Function) => {
					const c: any = new Dialog({ type: "confirm", message: message });
					const answer: boolean = await c.show();
					callback(answer);
				}}
			>
				<App />
			</Router>
		</Suspense>
		<div id="snackbar">snacks</div>
	</Provider>,
);
